<template lang="html">
  <v-list
    v-show="value.length"
    dense
  >
    <div
      v-for="(upload, i) in shownFiles"
      :key="upload.name"
      :class="`file-tile status-${upload.status}`"
    >
      <v-divider
        v-if="i > 0"
      />
      <v-list-item>
        <v-list-item-avatar>
          <v-btn
            v-if="upload.status === 'pending' && !uploading"
            icon
            @click="$emit('input', splice(i))"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-progress-circular
            v-if="upload.status === 'uploading'"
            :rotate="-90"
            :value="progressPercent({...upload.progress, total: upload.file.size })"
            :indeterminate="upload.progress.indeterminate"
            color="primary"
          />
          <v-icon
            v-if="upload.status === 'done'"
            color="success"
            large
          >
            mdi-check
          </v-icon>
          <v-icon
            v-if="upload.status === 'error'"
            color="error"
            large
          >
            mdi-alert-circle
          </v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ upload.name }}</v-list-item-title>
          <v-list-item-subtitle>
            <span
              v-if="upload.progress.current"
            >
              {{ formatSize(upload.progress.current ) }}
            </span>
            <span>{{ formatSize(upload.file.size) }}</span>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </div>
    <template
      v-if="hiddenCount > 0"
    >
      <v-divider />
      <v-list-item>
        <v-list-item-content>
          <div
            class="grey--text subtitle-1"
          >
            + {{ hiddenCount }} more...
          </div>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-list>
</template>

<script>
const progressReporter = {
  methods: {
    progressPercent(progress) {
      if (!progress.total) {
        return 0;
      }
      return Math.round((100 * (progress.current || 0)) / progress.total);
    },
  },
};

const sizeFormatter = {
  methods: {
    formatSize(size, { base = 1024, unit = 'B' } = {}) {
      if (size < base) {
        return `${size} ${unit}`;
      }

      let i;
      let val = size;
      for (i = 0; val >= base && i < 4; i += 1) {
        val /= base;
      }

      return `${val.toFixed(2)}  ${['', 'K', 'M', 'G', 'T'][i]}${unit}`;
    },
  },
};

export default {
  mixins: [progressReporter, sizeFormatter],
  props: {
    value: {
      type: Array,
      required: true,
    },
    maxShow: {
      type: Number,
      default: 10,
    },
    currentIndex: {
      type: Number,
      default: 0,
    },
    uploading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    shownFiles() {
      if (this.maxShow) {
        return this.value.slice(this.currentIndex, this.maxShow + this.currentIndex);
      }
      return this.value;
    },
    hiddenCount() {
      if (this.maxShow) {
        return Math.max(this.value.length - this.maxShow - this.currentIndex, 0);
      }
      return 0;
    },
  },
  methods: {
    splice(idx) {
      return [
        ...this.value.slice(0, idx),
        ...this.value.slice(idx + 1),
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.file-tile {
  transition:
    width 0.8s ease-in-out 1s,
    height 0.8s ease-in-out 1s,
    background-color 0.5s ease-in-out;
  width: 100%;
}
.file-tile.status-uploading {
  background-color: #fef4c9;
}
.file-tile.status-done {
  width: 0;
  height: 0;
  overflow: hidden;
}
</style>
